'use strict';

var truncate = require("./lib/truncate");
var getLength = require("utf8-byte-length/browser");
module.exports = truncate.bind(null, getLength);



//////////////////
// WEBPACK FOOTER
// ./~/truncate-utf8-bytes/browser.js
// module id = 1580
// module chunks = 0